import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useContext,
} from "react";
import RimMicroOptMetrics from "./Rim-metrics";
import "./Rim-metrics.css";
import metricConfig from "./Rim-metrics-config.json";
import { RootContext } from "../../../contexts/root-context";

function RimMetricsContainer() {
  const { rimData } = useContext(RootContext);

  const initialMetricsData = useMemo(
    () => ({
      Substation: [{ metricName: metricConfig.initialMetrics.Substation.metricName, metricScore:metricConfig.initialMetrics.Substation.defaultScore }],
      Assets: [{ metricName: metricConfig.initialMetrics.Assets.metricName, metricScore: metricConfig.initialMetrics.Assets.defaultScore }],
      User: [{ metricName: metricConfig.initialMetrics.User.metricName, metricScore: metricConfig.initialMetrics.User.defaultScore }],
      SuccessfulLogins: [{ metricName: metricConfig.initialMetrics.SuccessfulLogins.metricName, metricScore: metricConfig.initialMetrics.SuccessfulLogins.defaultScore }],
      UnSuccessfulLogins: [{ metricName: metricConfig.initialMetrics.UnSuccessfulLogins.metricName, metricScore: metricConfig.initialMetrics.UnSuccessfulLogins.defaultScore }],
      SecurityAlerts: [{ metricName: metricConfig.initialMetrics.SecurityAlerts.metricName, metricScore: metricConfig.initialMetrics.SecurityAlerts.defaultScore}],
    }),
    []
  );

  const [actualMetrics, setActualMetrics] = useState(initialMetricsData);

  const processRimMetricsData = useCallback(() => {
    if (!rimData || rimData.length === 0) return;

    let successfulLoginCount = 0;
    let unsuccessfulLoginCount = 0;
    const uniqueDeviceNames = new Set();
    const uniqueSubstations = new Set();
    const uniqueUsers = new Set();

    rimData.forEach((item) => {
      if (item.substation) uniqueSubstations.add(item.substation);
      if (item.device_name) uniqueDeviceNames.add(item.device_name);
      if (item.User) uniqueUsers.add(item.User);

      if (metricConfig.loginUalCodes.successful.includes(item.Ual)){
        successfulLoginCount++;
      } else if (
        (metricConfig.loginUalCodes.unsuccessful.includes(item.Ual))
      ) {
        unsuccessfulLoginCount++;
      }
    });

    const updatedMetrics = {
      Substation: [{
        metricName: metricConfig.initialMetrics.Substation.metricName,
        metricScore: uniqueSubstations.size.toString(),
      }],
      Assets: [{
        metricName: metricConfig.initialMetrics.Assets.metricName,
        metricScore: uniqueDeviceNames.size.toString(),
      }],
      User: [{
        metricName: metricConfig.initialMetrics.User.metricName,
        metricScore: uniqueUsers.size.toString(),
      }],
      SuccessfulLogins: [{
        metricName: metricConfig.initialMetrics.SuccessfulLogins.metricName,
        metricScore: successfulLoginCount.toString(),
      }],
      UnSuccessfulLogins: [{
        metricName: metricConfig.initialMetrics.UnSuccessfulLogins.metricName,
        metricScore: unsuccessfulLoginCount.toString(),
      }],
      SecurityAlerts: [{
        metricName: metricConfig.initialMetrics.SecurityAlerts.metricName,
        metricScore: metricConfig.initialMetrics.SecurityAlerts.defaultScore,
      }],
    };

    setActualMetrics(updatedMetrics);
  }, [rimData]);

  useEffect(() => {
    processRimMetricsData();
  }, [processRimMetricsData]);

  const metricComponents = useMemo(() => {
    return Object.entries(actualMetrics)
      .filter(([key]) => metricConfig.initialMetrics[key]?.isEnabled)
      .map(([key, legends],index) => (
        <div key={key} 
        className="col-sm-6 col-md-6 col-lg-4 col-xl-2 cybershield-rim-metrics "

          style={{ paddingLeft: "0px", marginLeft: index === 0 ? "24px" : "-8px" }}
        >
          <RimMicroOptMetrics position={3} legends={legends} />
        </div>
      ));
  }, [actualMetrics]);

  return (
    <div className="Rim-metrics-container-row">
      {metricComponents}
    </div>
  );
}

export default RimMetricsContainer;
